import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';
import { useCurrentNavigationValues } from '../contents/hooks';
import { useShowDigitalPracticeInformation } from '../user-management/hooks/use-show-digital-practice-information';

type NotificationsContextType = {
  sessionDoneNotification: boolean;
  setSessionDoneNotification: (value: boolean) => void;
};

const NotificationsContext = createContext<
  NotificationsContextType | undefined
>(undefined);

export function useNotifications() {
  const context = useContext(NotificationsContext);
  if (!context) {
    return {
      sessionDoneNotification: false,
      setSessionDoneNotification: () => {
        console.warn(
          'NotificationsProvider not found, notification state cannot be updated'
        );
      },
    };
  }
  return context;
}

type NotificationsProviderProps = {
  children: ReactNode;
};

export function NotificationsProvider({
  children,
}: NotificationsProviderProps) {
  const [sessionDoneNotification, setInternalSessionDoneNotification] =
    useState(false);
  const { courseOrder } = useCurrentNavigationValues();

  const { showDigitalPracticeInformation } = useShowDigitalPracticeInformation({
    courseOrder,
    menu: undefined,
  });

  const setSessionDoneNotification = (value: boolean) => {
    if (showDigitalPracticeInformation) {
      setInternalSessionDoneNotification(value);
    }
  };

  const value = {
    sessionDoneNotification,
    setSessionDoneNotification,
  };

  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
}
